module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s_main"
  }, [_c('h1', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("Abstract Status")]), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "context": _vm.self,
      "columns": _vm.colums,
      "data": _vm.papers,
      "no-data-text": "No data"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5677a8c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paper/Status.vue
// module id = 803
// module chunks = 10